export const IDS=[
    'home',
    'about',
    'skills',
    'projects',
    'experience',
    'contact'
]
